import React, { useState } from "react";
import { getAuth } from "firebase/auth";
import LocatieHarta from "./LocatieHarta.tsx";

const AdaugaBeneficiar = () => {
  const [formData, setFormData] = useState({ nume: "", prenume: "", cnp: "" });
  const [locatieData, setLocatieData] = useState({
    strada: "",
    numar: "",
    judet: "",
    oras: "",
    taraIdentificare: "",
  });

  const judeteRO = [
  "Alba", "Arad", "Argeș", "Bacău", "Bihor", "Bistrița-Năsăud", "Botoșani", "Brașov",
  "Brăila", "Buzău", "Caraș-Severin", "Călărași", "Cluj", "Constanța", "Covasna", "Dâmbovița",
  "Dolj", "Galați", "Giurgiu", "Gorj", "Harghita", "Hunedoara", "Ialomița", "Iași", "Ilfov",
  "Maramureș", "Mehedinți", "Mureș", "Neamț", "Olt", "Prahova", "Satu Mare", "Sălaj", "Sibiu",
  "Suceava", "Teleorman", "Timiș", "Tulcea", "Vaslui", "Vâlcea", "Vrancea",
  // București - sectoare ca județe separate
  "Sector 1", "Sector 2", "Sector 3", "Sector 4", "Sector 5", "Sector 6"
];

  const [cnpValid, setCnpValid] = useState(null); // null = neutru, true = valid, false = invalid

  // Adaugă un state pentru loading
  const [loading, setLoading] = useState(false);
  

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
const handleCnpChange = (e) => {
  let value = e.target.value.replace(/\D/g, ""); // doar cifre
  if (value.length <= 13) {
    setFormData({ ...formData, cnp: value });

    if (value.length === 13) {
      setCnpValid(true);
    } else {
      setCnpValid(false);
    }
  }
};

  
  const handleLocatieChange = (e) => {
    const { name, value } = e.target;
    setLocatieData({ ...locatieData, [name]: value });
  };

  const adaugaBeneficiarREST = async (data, locatie) => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) throw new Error("Nu ești autentificat");

    const idToken = await user.getIdToken();

    const response = await fetch(
      "https://us-central1-epafa-production.cloudfunctions.net/adaugaBeneficiarREST",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${idToken}`,
        },
        body: JSON.stringify({ ...data, locatie }),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Eroare la adăugare beneficiar");
    }

    return await response.json();
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  // Verificăm câmpurile obligatorii
  if (!formData.cnp || !formData.nume || !formData.prenume) {
    alert("Completează toate câmpurile obligatorii.");
    return;
  }

  // Verificăm județul
  if (!locatieData.judet) {
    alert("Selectează un județ înainte de a continua.");
    return;
  }

  setLoading(true); // începe loading

  try {
    const result = await adaugaBeneficiarREST(formData, locatieData);
    alert(result.message);
    setFormData({ nume: "", prenume: "", cnp: "" });
    setLocatieData({
      strada: "",
      numar: "",
      judet: "",
      oras: "",
      taraIdentificare: "",
    });
  } catch (error) {
    alert("Eroare: " + error.message);
  } finally {
    setLoading(false); // oprește loading indiferent de rezultat
  }
};


  return (
    <div className="container-fluid-dashboard">
      <div className="titlu-container">
        <h2>Adaugă un beneficiar nou</h2>
      </div>
      <form onSubmit={handleSubmit}>
        {/* Form Nume, Prenume, CNP */}
        <div className="row">
          <div className="col-md-6 mb-2">
            <input
              type="text"
              name="nume"
              placeholder="Nume"
              className="form-control"
              value={formData.nume}
              onChange={handleFormChange}
              required
            />
          </div>
          <div className="col-md-6 mb-2">
            <input
              type="text"
              name="prenume"
              placeholder="Prenume"
              className="form-control"
              value={formData.prenume}
              onChange={handleFormChange}
              required
            />
          </div>
<div className="col-md-6 mb-2 position-relative">
  <input
    type="text"
    name="cnp"
    placeholder="CNP"
    className={`form-control pe-5 ${
      cnpValid === null
        ? ""
        : cnpValid
        ? "border-success"
        : "border-danger"
    }`}
    value={formData.cnp}
    onChange={handleCnpChange}
    required
  />
  {cnpValid && (
    <span
      className="text-success position-absolute"
      style={{
        right: "12px",
        top: "0",
        bottom: "0",
        display: "flex",
        alignItems: "center",
        pointerEvents: "none", // să nu încurce click-ul
        fontSize: "1.2rem",
      }}
    >
      ✔
    </span>
  )}
</div>



<style jsx>{`
  .glow-success {
    box-shadow: 0 0 8px 2px rgba(0, 200, 0, 0.6);
  }
  .glow-danger {
    box-shadow: 0 0 8px 2px rgba(255, 0, 0, 0.6);
  }
`}</style>

        </div>

        <hr />

        <h2>Locația unde a fost identificat</h2>
        <LocatieHarta
          onLocationSelect={(adresa) =>
            setLocatieData((prev) => ({ ...prev, ...adresa }))
          }
        />

       <div className="row">
  {["strada", "numar", "oras", "taraIdentificare"].map((field) => (
    <div key={field} className="col-md-6 mb-2">
      <input
        type="text"
        name={field}
        placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
        className="form-control"
        value={locatieData[field]}
        onChange={handleLocatieChange}
      />
    </div>
  ))}

  <div className="col-md-6 mb-2">
    <select
      name="judet"
      className="form-control"
      value={locatieData.judet}
      onChange={handleLocatieChange}
          required   

    >
      <option value="">Selectează județ</option>
      {judeteRO.map((j) => (
        <option key={j} value={j}>{j}</option>
      ))}
    </select>
  </div>
</div>


<button type="submit" className="btn btn-primary" disabled={loading}>
  {loading ? (
    <>
      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      Se salvează...
    </>
  ) : (
    "Adaugă beneficiar"
  )}
</button>


      </form>
    </div>
  );
};

export default AdaugaBeneficiar;
